import * as React from 'react';
import {Fragment, useEffect, useRef, useState} from 'react';
import {CSSObject, styled, Theme, useTheme} from '@mui/material/styles';
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import {Menu as MenuIcon} from "@mui/icons-material";
import {SwipeableDrawer} from "@mui/material";
import SideMenuList from "./SideMenuList";
import {isBrowser} from "react-device-detect";
import {useWindowSize} from "../../config/globalConfig";

const SideMenu = (props: any) => {
    const theme = useTheme();
    const {width} = useWindowSize();
    const drawer = useRef<any>(null);
    const [selected, setSelected] = useState<any[]>([]);
    const [drawerWidth, setDrawerWidth] = useState(220);
    const [showMenu, setShowMenu] = useState(isBrowser && width > 635);
    const openedMixin = (theme: Theme): CSSObject => ({
        minWidth: drawerWidth,
        padding: `0 ${theme.spacing(1)}`,
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        overflowX: 'hidden',
    });

    const closedMixin = (theme: Theme): CSSObject => ({
        transition: theme.transitions.create('width', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: `calc(${theme.spacing(7)} + 1px)`,
        [theme.breakpoints.up('sm')]: {
            width: `calc(${theme.spacing(8)} + 1px)`,
        },
    });

    const Drawer = styled(MuiDrawer, {shouldForwardProp: (prop) => prop !== 'open'})(
        ({theme, open}) => ({
            flexShrink: 0,
            whiteSpace: 'nowrap',
            boxSizing: 'border-box',
            ...(open && {
                ...openedMixin(theme),
                '& .MuiDrawer-paper': openedMixin(theme),
            }),
            ...(!open && {
                ...closedMixin(theme),
                '& .MuiDrawer-paper': closedMixin(theme),
            }),
        }),
    );

    const handleDrawerClick = () => {
        props.setMenuIsOpen(!props.menuIsOpen);
    }

    useEffect(() => {
        if (props.menuIsOpen) {
            setDrawerWidth(220);
            setTimeout(() => {
                setDrawerWidth(drawer.current?.firstChild.clientWidth > 220 ? drawer.current?.firstChild.clientWidth : 220);
            }, 10);
        } else {
            setDrawerWidth(220);
        }
    }, [props.menuIsOpen, selected]);

    useEffect(() => {
        setShowMenu(isBrowser && width > 635);
    }, [isBrowser, width]);

    return (
        <Fragment>
            {showMenu ?
                <Box sx={{
                    display: 'flex',
                    '& .MuiPaper-root': {
                        marginTop: '48px'
                    },
                    '& .MuiDrawer-paper': {
                        boxSizing: 'border-box',
                        backgroundColor: theme.palette.primary.main
                    },
                    '& .subItem': {
                        paddingLeft: theme.spacing(2),
                        paddingY: theme.spacing(1)
                    },
                    '& .default': {
                        color: theme.palette.primary.contrastText,
                        textTransform: 'capitalize'
                    },
                    '& .menuSelected': {
                        color: theme.palette.accent.main,
                        backgroundColor: theme.palette.accent.contrastText,
                        borderRadius: theme.spacing(1),
                        textTransform: 'capitalize',
                        fontWeight: 'bold',
                        '&:hover': {
                            color: theme.palette.accent.main,
                            backgroundColor: theme.palette.accent.contrastText,
                            borderRadius: theme.spacing(1),
                            textTransform: 'capitalize',
                            fontWeight: 'bold'
                        },
                    },

                }}>
                    <Drawer ref={drawer} variant="permanent" open={props.menuIsOpen}>
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: props.menuIsOpen ? 'flex-end' : 'center',
                            padding: 1,
                        }}>
                            <IconButton sx={{
                                color: theme.palette.primary.contrastText
                            }} onClick={handleDrawerClick}>
                                {!props.menuIsOpen ? <MenuIcon/> : <ChevronLeftIcon/>}
                            </IconButton>
                        </Box>
                        <Divider/>
                        {
                            props.menuIsOpen &&
                            <SideMenuList selected={selected} setSelected={setSelected} setOpen={props.setMenuIsOpen}/>
                        }
                    </Drawer>
                </Box>
                :
                <SwipeableDrawer
                    anchor={"left"}
                    open={props.menuIsOpen}
                    onClose={() => props.setMenuIsOpen(false)}
                    onOpen={() => props.setMenuIsOpen(true)}
                    sx={{
                        '& .MuiPaper-root': {
                            marginTop: '48px'
                        },
                        '& .MuiDrawer-paper': {
                            boxSizing: 'border-box',
                            backgroundColor: theme.palette.primary.main
                        },
                        '& .subItem': {
                            paddingLeft: theme.spacing(2),
                            paddingY: theme.spacing(1)
                        },
                        '& .default': {
                            color: theme.palette.primary.contrastText,
                            textTransform: 'capitalize'
                        },
                        '& .menuSelected': {
                            color: theme.palette.accent.main,
                            backgroundColor: theme.palette.accent.contrastText,
                            borderRadius: theme.spacing(1),
                            textTransform: 'capitalize',
                            fontWeight: 'bold',
                            '&:hover': {
                                color: theme.palette.accent.main,
                                backgroundColor: theme.palette.accent.contrastText,
                                borderRadius: theme.spacing(1),
                                textTransform: 'capitalize',
                                fontWeight: 'bold'
                            },
                        },

                    }}
                >
                    <SideMenuList selected={selected} setSelected={setSelected} setOpen={props.setMenuIsOpen}/>
                </SwipeableDrawer>
            }
        </Fragment>
    );
}

export default SideMenu;